module.exports = __webpack_public_path__ + "static/media/bagy15.4a378214.png";